// React
import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { compose } from 'redux'

// Components
import { ModalCartPicker } from 'store/modules/cart/CartPicker/Modal'

// Hooks
import { useDatePicker } from 'store/hooks/useDatePicker'
import { useOrm } from 'shared/utils/useOrm'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import ClientActions from 'store/v2/redux/actions/client'

const Modal = () => {
  const { isOpen, close } = useDatePicker()

  const cartId = useSelector((state) => state.client.cartId)
  const cart = useOrm('carts', (carts) => carts.getById(cartId || window.booqableOptions.cart?.id))
  const behavior = useSelector((state) => state.settings.get('store.behaviors.add_button'))

  const cartHasLines = useMemo(() => cart?.lines && cart.lines.length > 0, [cart])

  const onSave = useCallback(() => {
    if (behavior === 'checkout' && !ClientActions.evaluateCartOverdue() && cartHasLines) {
      ClientActions.setCheckingOut()
    }
  })

  if (!cart) return null

  return <ModalCartPicker open={isOpen} onClose={close} onSave={onSave} />
}

Modal.displayName = 'DatePickerModal'

Modal.propTypes = {
  cart: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  brandingColor: PropTypes.string,
  t: PropTypes.func
}

const decoratedComponent = compose(withStore, withTheme)(Modal)

registerCustomElement('bq-date-picker-modal', decoratedComponent, {
  styleSheetTarget: document.body
})

export default decoratedComponent
